import _axios from "../common/axiosCommon.js";

async function login(data) {
    return await _axios({
        method: 'post',
        url: 'user/login',
        data: {
            user_id: data.userID,
            password: data.password,
        },
    }).then((response) => {
        return response.data
    })
}
async function reLogin(data) {
    return await _axios({
        method: 'post',
        url: 'user/relogin',
        data
    }).then((response) => {
        return response.data
    })
}
async function getNickByUid(uid) {//
    return await _axios({
        method: 'post',
        url: 'user/getNickByUid',
        data: {
            uid,
        },
    }).then((response) => {
        return response.data
    })
}
async function getAvatarByUid(uid) {//
    return await _axios({
        method: 'post',
        url: 'user/getAvatarByUid',
        data: {
            uid,
        },
    }).then((response) => {
        return response.data
    })
}
async function getFortune(uid) {
    return await _axios({
        method: 'post',
        url: 'user/getFortune',
        data: {
            uid,
        },
    }).then((response) => {
        return response.data
    })
}
async function punchIn(uid) {
    return await _axios({
        method: 'post',
        url: 'user/punch_in',
        data: {
            uid,
        },
    }).then((response) => {
        return response.data
    })
}

async function getUserInfo(uid) {
    const response = await _axios({
        method: 'post',
        url: 'user/getUserInfo',
        data: {
            uid,
        },
    });
    return response.data;
}

export const UserApi = {
    getNickByUid,//暂时没有用到
    getAvatarByUid,//暂时没有用到
    login,
    reLogin,
    getFortune,//scratch 里没用到
    punchIn,//scratch 里没用到
    getUserInfo,//scratch 里没用到
}
